"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  p: {
    marginBottom: 8
  },
  inlineCode: {
    padding: '1px 3px',
    fontSize: 16
  },
  code: {
    padding: 16,
    borderRadius: 3,
    lineHeight: 1.45
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/typography/Markdown/styles.js
// module id = ./node_modules/quark-web/components/typography/Markdown/styles.js
// module chunks = 0